// local
// modals
import { PERIOD_TYPE } from 'salvus-shared/consts/patient';
// lib
import { toSearchableString, sortString, sortNumber } from 'app/lib/helper';

const SORT_PATIENT = function(a, b) {
    let result = sortNumber(a.status, b.status);
    if (result !== 0) {
        return result;
    }
    return sortString(a.name, b.name);
};

const filterByTerm = (item, term) => toSearchableString(item.name).includes(toSearchableString(term));

const filterByType = (item, filters) => filters.includes(item.periodType);

const filterData = (data, term, filters) => {
    const result = data.filter(item => {
        return filterByTerm(item, term) && filterByType(item, filters);
    });
    result.sort(SORT_PATIENT);
    return result;
};

const initialState = () => ({
    loading: false,
    data: [],
    filter: {
        term: '',
        type: [PERIOD_TYPE.IF_NECESSARY, PERIOD_TYPE.CONTINUOUS_USE],
        data: [],
    },
});

const ACTION_KEY = 'PATIENT_LIST';

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${ACTION_KEY}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${ACTION_KEY}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${ACTION_KEY}_FULFILLED`: {
            const data = action.payload;
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${ACTION_KEY}_CREATE`: {
            const newRow = action.payload;
            // add the new item to the array
            const data = [...state.data, newRow];
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${ACTION_KEY}_UPDATE`: {
            const updatedRow = action.payload;
            // update the row with the same ID with new data
            const data = state.data.map(row => (row.id === updatedRow.id ? updatedRow : row));
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${ACTION_KEY}_SEARCH`: {
            const term = action.payload;
            const data = filterData(state.data, term, state.filter.type);
            return {
                ...state,
                filter: {
                    ...state.filter,
                    term,
                    data,
                },
            };
        }
        case `${ACTION_KEY}_FILTER`: {
            const type = action.payload;
            const data = filterData(state.data, state.filter.term, type);
            return {
                ...state,
                filter: {
                    ...state.filter,
                    type,
                    data,
                },
            };
        }
        case `${ACTION_KEY}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};

export default reducer;
